import { useState } from 'react';
import { FormField } from '../../../school_panel/components/ui';
import { fieldClass } from '../../../school_panel/lib/fieldClass';
import { FieldError, FormFooter, type FormProps, SourceFields, useQuestionSource } from './shared';

const LETTERS = ['A', 'B', 'C', 'D'];

export default function McqForm({ initial, saving, errors, onSave, onCancel, chapters }: FormProps) {
  const [text, setText] = useState(initial?.text ?? '');
  const [options, setOptions] = useState<string[]>(initial?.options?.length === 4 ? initial.options : ['', '', '', '']);
  const [answer, setAnswer] = useState<string>(initial?.answer ?? '');
  const [explanation, setExplanation] = useState(initial?.explanation ?? '');
  const source = useQuestionSource(initial);
  const [local, setLocal] = useState<Record<string, string>>({});

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const err: Record<string, string> = {};
    if (!text.trim()) err.text = 'Enter the question.';
    if (options.some((o) => !o.trim())) err.options = 'Fill in all four choices.';
    if (!answer) err.answer = 'Pick the correct answer.';
    setLocal(err);
    if (Object.keys(err).length) return;
    onSave({
      type: 'multiple_choice', text: text.trim(), options: options.map((o) => o.trim()), answer,
      ...(explanation.trim() ? { explanation: explanation.trim() } : {}), ...source.payload,
    });
  };
  const e = { ...local, ...errors };

  return (
    <form onSubmit={submit} noValidate className="space-y-4">
      <FormField label="Question text" htmlFor="mcq-text" required error={e.text}>
        <textarea id="mcq-text" rows={3} className={fieldClass} value={text} onChange={(ev) => setText(ev.target.value)} />
      </FormField>
      <div className="space-y-2">
        {LETTERS.map((L, i) => (
          <div key={L} className="flex items-center gap-3">
            <input type="radio" className="yada-radio" name="mcq-answer" aria-label={`Correct answer ${L}`}
              checked={answer === L} onChange={() => setAnswer(L)} />
            <input aria-label={`Option ${L}`} placeholder={`Choice ${L}`} className={fieldClass} value={options[i]}
              onChange={(ev) => setOptions(options.map((o, j) => (j === i ? ev.target.value : o)))} />
          </div>
        ))}
        <FieldError error={e.options} />
        <FieldError error={e.answer} />
      </div>
      <FormField label="Explanation (optional)" htmlFor="mcq-expl" error={e.explanation}>
        <textarea id="mcq-expl" rows={2} className={fieldClass} value={explanation} onChange={(ev) => setExplanation(ev.target.value)} />
      </FormField>
      <SourceFields source={source} chapters={chapters} errors={e} idPrefix="mcq" />
      <FormFooter saving={saving} onCancel={onCancel} />
    </form>
  );
}
